import { render, staticRenderFns } from "./AreaDetailsPopoutButton.vue?vue&type=template&id=af65b4d4&scoped=true"
import script from "./AreaDetailsPopoutButton.vue?vue&type=script&lang=ts"
export * from "./AreaDetailsPopoutButton.vue?vue&type=script&lang=ts"
import style0 from "./AreaDetailsPopoutButton.vue?vue&type=style&index=0&id=af65b4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af65b4d4",
  null
  
)

export default component.exports